<template>
  <div class="study-info-container" id="Study-info-carousel" v-if="onBoardingDetails">
    <div id="join-study-carousel" class="carousel slide" data-ride="carousel">
      <!-- The slideshow -->
      <div class="study-section pt-27 pb-27">
        <div class="text-center">
          <img v-if="getStudyIcon" :src="getStudyIcon" :alt="globalElements.siteTitle" class="study-logo" />
        </div>
      </div>
      <div class="carousel-inner ml-30 mr-30">
        <div class="carousel-item" v-for="(screen, i) of onBoardingDetails.screens" :key="i" :class="{ active: i == 0 }">
          <div class="text-center">
            <p
              class="study-title m-0 primary-text"
              v-translate:dynamic_string="{
                key: `${screen.details}_title`,
                val: lang,
                html: screen.title
              }"
            >
              {{ screen.title }}
            </p>
          </div>
          <div :class="['study-info-section', screen.type !== 'instruction' ? 'mt-20' : '']">
            <div class="text-content text-center" v-if="screen.type == 'instruction'" v-quill-html:participantStudyVideos="getTranslation(screen.details)"></div>
            <div class="text-content text-center" v-else v-quill-html:participantStudyVideos.src="screen.details"></div>
          </div>
        </div>
      </div>
      <!-- Indicators -->
      <ul class="carousel-indicators">
        <li :class="{ active: i == 0 }" data-target="#join-study-carousel" data-slide-to="1" v-for="(screen, i) of onBoardingDetails.screens" :key="i"></li>
      </ul>
      <!-- Left and right controls -->
      <div class="carousel-arrow">
        <a class="carousel-control-prev" @click="getParticipantVideos" href="#join-study-carousel" data-slide="prev">
          <span class="carousel-control-prev-icon"> <i class="fa fa-angle-left" style="color:#c4c4c4; font-size: 32px; cursor: pointer;"></i></span>
        </a>
        <a class="carousel-control-next" @click="getParticipantVideos" href="#join-study-carousel" data-slide="next">
          <span class="carousel-control-next-icon"><i class="fa fa-angle-right" style="color:#c4c4c4;font-size: 32px; cursor: pointer;"></i></span>
        </a>
      </div>
    </div>
    <div class="progress-section">
      <div v-if="!isJoinButtonDisabled" class="text-center join-study-btn">
        <button class="btn join-study-btn-1" v-translate:join_study="lang" @click="letsGoTo">
          Join Study
        </button>
      </div>
      <div v-if="isLoginButtonEnable" class="text-center join-study-btn">
        <button class="btn join-study-btn-2 mt-15 primary-bg" @click="goToLogin" v-translate:sing_in="lang">
          Sign In
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import { mapGetters } from "vuex";
import _ from "lodash";
import { Bitrise, Widget, ParticipantPortal } from "@/components/services/participant-service";

export default {
  name: "join-intro",
  components: {},
  props: ["isLoginButtonEnable", "isJoinButtonDisabled", "lang"],
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      bitrise: new Bitrise(),
      intoDetails: "",
      introScreen: {},
      onBoardingDetails: null,
      participantStudyVideos: null
    };
  },
  computed: {
    ...mapGetters(["participant", "getParticipantStudyVideos"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    getStudyIcon() {
      return this.bitrise.getImage("logo");
    }
  },
  mounted() {
    this.loadScreens();
    this.getParticipantVideos();
  },
  methods: {
    getParticipantVideos() {
      this.participantStudyVideos = _.cloneDeep(this.getParticipantStudyVideos);
    },
    getTranslation(details) {
      return this.widget.i18nActivities(`${this.$route.params.studyId}_INSTRUCTION_details`, this.lang) == false ? details : this.widget.i18nActivities(`${this.$route.params.studyId}_INSTRUCTION_details`, this.lang);
    },
    letsGoTo() {
      this.$emit("updateActiveScreen", "isReadyToJoinStudy");
    },
    goToLogin() {
      this.$router.push({
        name: "participants-portal-auth-login",
        params: { studyId: this.$route.params.studyId }
      });
    },
    getBitriseHtmlUrl(key) {
      return this.bitrise.getParticipantsPortalSignedHTMLURL(key);
    },
    loadScreens() {
      nprogress.start();
      this.bitrise = new Bitrise();
      const studyOverviewObj = this.bitrise.getJsonData("study_overview");
      if (studyOverviewObj) {
        studyOverviewObj.then(
          response => {
            response.screens.forEach(screen => {
              if (screen.type == "instruction") {
                window.localStorage.setItem("pw-studyName", screen.title);
              }
            });
            this.onBoardingDetails = response;
            nprogress.done();
          },
          error => {
            nprogress.done();
            const message = this.widget.translate(error.message, "Data sync failed, please try again after some time.");
            if (message) {
              this.$toastr.error(message);
            }
          }
        );
      }
    }
  }
};
</script>

<style>
.carousel-inner {
  width: auto !important;
  height: 435px;
  overflow: auto;
}
.join-study-btn-1,
.join-study-btn-2 {
  font-size: 17px;
  color: #ffffff;
  width: 100%;
  margin: auto;
  height: 44px;
  border-radius: 12px;
  background-color: var(--secondary);
}
.progress-section .join-study-btn .join-study-btn-1 {
  margin-top: 76px;
  max-width: 100% !important;
}
#join-study-carousel .study-title {
  padding: 0 !important;
}
</style>
